import {t} from '@lingui/core/macro';

import IApiViolation from 'shared/api/model/IApiViolation';
import {IRequestHeaderRow, RequestHeaders} from 'features/http/model/HttpMonitor/IRequestHeader';

export const REQUEST_HEADERS_MAX = 20;
export const HEADERS_ROOT_ERROR = 'headers.root' as unknown as 'headers';
export const REQUEST_HEADER_NAME_MAX_LENGTH = 256;
export const REQUEST_HEADER_VALUE_MAX_LENGTH = 1024;

export const isUserAgentHeader = (name: string): boolean => name.trim().toLowerCase() === 'user-agent';

export const isUserAgentLocked = (name: string, userAgentEnabled: boolean): boolean => (
    !userAgentEnabled && isUserAgentHeader(name)
);

export const isHostHeader = (name: string): boolean => name.trim().toLowerCase() === 'host';

export const isHostLocked = (name: string, customHostEnabled: boolean): boolean => (
    !customHostEnabled && isHostHeader(name)
);

export const validateHeaderName = (name: string, value: string): true | string => (
    !name.trim() && value ? t`Укажите имя заголовка` : true
);

interface IFieldErrorLike {
    message?: unknown,
    root?: {message?: unknown},
}

type HeadersErrors = IFieldErrorLike & Record<number, {name?: {message?: unknown}} | undefined>;

const asMessage = (message: unknown): string | undefined => (
    typeof message === 'string' && message ? message : undefined
);

export const getHeadersErrorMessage = (errors?: unknown): string | undefined => {
    const error = errors as HeadersErrors | undefined;
    return asMessage(error?.message) ?? asMessage(error?.root?.message);
};

export const getHeaderNameError = (errors: unknown, index: number): string | undefined => (
    asMessage((errors as HeadersErrors | undefined)?.[index]?.name?.message)
);

export const isHeadersViolation = (propertyPath?: string): boolean => (
    !!propertyPath && /^headers([.[]|$)/.test(propertyPath)
);

export interface IHeadersViolations {
    headersMessage?: string,
    others: IApiViolation[],
}

export const splitHeadersViolations = (violations?: IApiViolation[]): IHeadersViolations => {
    const headers: string[] = [];
    const others: IApiViolation[] = [];

    (violations ?? []).forEach((violation) => {
        if (isHeadersViolation(violation.propertyPath)) {
            headers.push(violation.message);
        } else {
            others.push(violation);
        }
    });

    return headers.length > 0 ? {headersMessage: headers.join('\n'), others} : {others};
};

export function headersToRows(headers?: RequestHeaders | []): IRequestHeaderRow[] {
    if (!headers || Array.isArray(headers)) {
        return [];
    }

    return Object.entries(headers).map(([name, value]) => ({name, value}));
}

export function rowsToHeaders(rows?: IRequestHeaderRow[]): RequestHeaders {
    return (rows ?? []).reduce<RequestHeaders>((acc, {name, value}) => {
        const key = name.trim();
        if (key || value) {
            acc[key] = value;
        }
        return acc;
    }, {});
}
